import React, { useEffect, useRef, useState } from "react";
import styles from "./Header.module.css";

import AccountIcon from "./AccountIcon";
import IconExpand from "../Images/IconExpand";

import { signOut } from "firebase/auth";
import { auth } from "../firebaseConfig";
import { useNavigate } from "react-router-dom";

import { useUsers } from "../Commoncontext/UsersContext";
import { useSelectedCompany } from "../Commoncontext/SelectedCompanyContext";
import { useCompany } from "../Commoncontext/CompanyContext";

function Header() {
  const navigate = useNavigate();
  const { user } = useUsers();

  // 🔹 Valinta (AINOA paikka jossa tätä muutetaan)
  const { setSelectedCompanyId } = useSelectedCompany();

  // 🔹 Rikas company-data (vain lukua)
  const { companyName, companyColor } = useCompany();

  const [showCompanyDropdown, setShowCompanyDropdown] = useState(false);
  const [showUserDropdown, setShowUserDropdown] = useState(false);

  const companyDropdownRef = useRef(null);
  const userDropdownRef = useRef(null);

  /* ============================================================================
     Sulje dropdownit klikkauksella ulkopuolelle
  ============================================================================ */
  useEffect(() => {
    function handleClickOutside(e) {
      if (
        showCompanyDropdown &&
        companyDropdownRef.current &&
        !companyDropdownRef.current.contains(e.target)
      ) {
        setShowCompanyDropdown(false);
      }

      if (
        showUserDropdown &&
        userDropdownRef.current &&
        !userDropdownRef.current.contains(e.target)
      ) {
        setShowUserDropdown(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [showCompanyDropdown, showUserDropdown]);

  /* ============================================================================
     Navigation helpers
  ============================================================================ */
  const handleSignOut = async () => {
    setShowUserDropdown(false);
    try {
      await signOut(auth);

      localStorage.removeItem("users_cache_etag_v1");
      localStorage.removeItem("sr_cache_etag_v1");
      localStorage.removeItem("ann_cache_etag_v2");
      localStorage.removeItem("documents_cache_etag_v1");

      window.location.href = "/login";
    } catch (err) {
      console.error("Logout failed", err);
    }
  };

  const navigateAndClose = (path) => {
    setShowUserDropdown(false);
    navigate(path);
  };

  /* ============================================================================
     Render
  ============================================================================ */
  return (
    <div
      className={styles.header}
    >
      {/* ================= Company ================= */}
      <div className={styles.asOyInfo}>
        <span className={styles.asOyName}>
          {companyName || " "}
        </span>

        {user?.companies?.length > 1 && (
          <div
            className={styles.menuContainer}
            ref={companyDropdownRef}
          >
            <div
              onClick={() =>
                setShowCompanyDropdown((v) => !v)
              }
              style={{ cursor: "pointer" }}
            >
              <IconExpand style={{ marginRight: "55px"}}/>
            </div>

            {showCompanyDropdown && (
              <div className={styles.menuItems}>
                {user.companies.map((companyId) => (
                  <div
                    key={companyId}
                    className={styles.menuItem}
                    onClick={() => {
                      setSelectedCompanyId(companyId);
                      setShowCompanyDropdown(false);
                    }}
                  >
                    {user.companyNames[companyId]}
                  </div>
                ))}
              </div>
            )}
          </div>
        )}
      </div>

      {/* ================= User ================= */}
      <div className={styles.userInfo}>
        {user?.etunimi && (
          <span className={styles.userName}>
            {user.etunimi} {user.sukunimi}
          </span>
        )}

        <div
          className={styles.menuContainer}
          ref={userDropdownRef}
        >
          <div
            onClick={() =>
              setShowUserDropdown((v) => !v)
            }
            style={{ cursor: "pointer" }}
          >
            <AccountIcon
              profileImageUrl={user?.profiilikuvaurl}
              width="35px"
              height="35px"
              border={false}
              style={{ marginRight: "55px" }}
            />
          </div>

          {showUserDropdown && (
            <div className={styles.menuItems2}>
              <div
                className={styles.menuItem}
                onClick={() =>
                  navigateAndClose("/owninformation")
                }
              >
                Omat tiedot
              </div>
              <div
                className={styles.menuItem}
                onClick={() =>
                  navigateAndClose("/consent")
                }
              >
                Tietosuojaseloste
              </div>
              <div
                className={styles.menuItem}
                onClick={() =>
                  navigateAndClose("/change-password")
                }
              >
                Vaihda salasana
              </div>
              <div
                className={styles.menuItem}
                onClick={handleSignOut}
              >
                Kirjaudu ulos
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default Header;
